import navigator from './entry.vue'

navigator.install = function (Vue) {
  Vue.component(navigator.name, navigator)
}

export default navigator